import React, { Component } from "react";

import { ModalOverlay, Gradient } from "app/NativeComponents/common";

import BadgeModal from "./BadgeModal";

import { CloseButton } from "app/NativeComponents/snippets";

class Body extends Component {
  render() {
    return (
      <ModalOverlay
        onPress={() => {
          this.props.updateBadge({
            token: this.props.token,
            payload: { badge_id: this.props.badge.id },
            type: "seen_badge"
          });
        }}
      >
        <Gradient
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
          color1={
            this.props.badge.gold_badge == 1
              ? "rgba(187,155,73, 0.45)"
              : "rgba(49,204,229, 0.45)"
          }
          color2={
            this.props.badge.gold_badge == 1
              ? "rgba(235,209,151, 0.45)"
              : "rgba(78,232,195, 0.45)"
          }
        >
          <BadgeModal {...this.props} />
          <CloseButton
            style={{
              paddingTop: 30,
              width: "100%",
              height: "100%",
              alignItems: "flex-end"
            }}
            onPress={() => {
              this.props.updateBadge({
                token: this.props.token,
                payload: { badge_id: this.props.badge.id },
                type: "seen_badge"
              });
            }}
            color={"#ffffff"}
          />
        </Gradient>
      </ModalOverlay>
    );
  }
}

export default Body;
